const theme = {
  lightGrey: '#F2F2F2',
  deepNavy: '#152840',
  darkGrey: '#2D2D2D',
  dirtyGold: '#DFCD81',
  lightGold: '#F8F3A3',
  veryLightGold:'#F6F3A3',
  tiffany: '#C9EEF2',
  blackish: '#01040D',
  lightNavy:"#47546C",
  
  fontFamily: 'Open Sans'
}

export default theme;